export const normalizeRole = role => String(role ?? '').trim().toLowerCase();

/**
 * Returns true when userRole is in the allowed list.
 * An empty / absent allowed list means "any authenticated user" (public route).
 */
export function hasRole(userRole, allowed) {
  if (!allowed || allowed.length === 0) return true;
  return allowed.map(normalizeRole).includes(normalizeRole(userRole));
}